import {
  AdminCard,
  AdminPage,
  useBlueprintAdmin,
  AdminToastTimed,
} from '@deloitte-us-consulting-dd/blueprint-ux-admin';
import { AdminScopedAPI } from '@deloitte-us-consulting-dd/blueprint-sdk-core';

import { Button } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';

const CategoryTagDelete = () => {
  const { config } = useBlueprintAdmin();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [error, setError] = useState(false);

  const deckAPI = new AdminScopedAPI(config, 'DeckAPI');

  const handleDelete = async (e) => {
    // SEND TO DELETE
    e.stopPropagation();
    e.preventDefault();

    await deckAPI
      .delete({ path: `/admin/decks/meta/categories/${id}` })
      .then((res) => {
        if (res.success) {
          navigate(`/categories`);
        } else {
          setError(true);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleCancel = (e) => {
    e.stopPropagation();
    e.preventDefault();
    navigate(`/categories/${id}`);
  };

  return (
    <>
      {error && (
        <AdminToastTimed
          message='Error deleting category, please make sure there are no tags in this tag category before deleting'
          trigger={error}
          severity='error'
          time={100000}
        />
      )}
      {id && (
        <AdminPage title='Delete Tag Category'>
          <AdminCard title=''>
            <h4>Are you sure you want to delete {id} </h4>

            <Button onClick={(e) => handleDelete(e)} color='error'>
              Confirm Deletion
            </Button>
            <Button onClick={(e) => handleCancel(e)}>Cancel</Button>
          </AdminCard>
        </AdminPage>
      )}
    </>
  );
};
export default CategoryTagDelete;
